<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">

          <button
            class="content-nav-btn"
            type="button"
            :class="{'content-nav-active':newstype == 2}"
            @click="setNewsType(2)"
          >
            <span>行业动态</span>
          </button>

            <button
            class="content-nav-btn"
            type="button"
            :class="{'content-nav-active':newstype == 1}"
            @click="setNewsType(1)"
          >
            <span>公司新闻</span>
          </button>
        </div>

        <div class="section-title">
          <h2>{{ newstype == 1 ? "公司新闻" : "行业动态" }}</h2>
        </div>

        <div class="content-nav-item" v-if="newsList.length">
          <article class="item-list" v-for="(item,index) in newsList" :key="index">
            <router-link
              class="text-decoration card-link"
              :to="{ name: 'newsdetails', params: { id: item.id }}"
            >
              <div class="item-img" v-lazy:background-image="imgserver + item.img"></div>
              <div class="item-list-body">
                <div class="item-list-meta">
                  <span>{{ newstype == 1 ? "公司新闻" : "行业动态" }}</span>
                  <time>{{ item.createTime }}</time>
                </div>
                <h3 class="item-list-title" v-html="item.title"></h3>
                <p class="item-list-content">{{ formatContent(item.content) }}</p>
                <div class="item-list-more">
                  <span>查看详情</span>
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </router-link>
          </article>
        </div>

        <div class="empty-news" v-else-if="!loading">
          <i class="el-icon-document"></i>
          <p>暂无相关资讯</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 2
    };
  },
  methods: {
    setNewsType(type) {
      if (this.newstype === type) return;
      this.newstype = type;
    },
    loadData() {
      this.loading = true;
      this.$http
        .get(`News/Search?type=${this.newstype}&count=6`)
        .then(response => {
          this.newsList = response.result || [];
        })
        .catch(error => {
          window.console.log(error);
          this.newsList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatContent(content) {
      if (!content) return "";
      return content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  min-height: 100%;
  background: #eef4f8;
  position: relative;

  &-section {
    width: 100%;
    padding: 0 0 56px;

    &-content {
      width: min(1240px, 92%);
      margin: -34px auto 0;
      padding: 0 42px 52px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
      position: relative;
      z-index: 5;

      .content-nav {
        width: min(360px, 100%);
        min-height: 50px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        align-items: center;
        position: relative;
        top: -29px;
        padding: 4px;
        box-sizing: border-box;
        border: 1px solid #d9e7f1;
        border-radius: 999px;
        background: #f7fbfe;
        box-shadow: 0 12px 28px rgba(18, 48, 78, 0.08);
        z-index: 6;

        &-btn {
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          border: 0;
          border-radius: 999px;
          background: transparent;
          color: #31465d;
          font-family: inherit;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
        }

        &-btn:hover {
          color: #156da8;
        }

        .content-nav-active {
          box-sizing: border-box;
          border: 1px solid rgba(44, 172, 226, 0.46);
          background: linear-gradient(180deg, #e9f8ff, #d4efff);
          color: #075b94;
          box-shadow: inset 0 0 14px rgba(95, 204, 255, 0.22), 0 10px 22px rgba(21, 109, 168, 0.14);
        }
      }

      .section-title {
        margin: 0 auto 28px;
        text-align: center;

        h2 {
          color: #142235;
          font-size: 34px;
          line-height: 1.25;
          font-weight: 700;
        }
      }

      .content-nav-item {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 360px));
        justify-content: center;
        gap: 22px;

        .item-list {
          min-height: 368px;
          border: 1px solid #e3edf5;
          border-radius: 8px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
          transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;

          &:hover {
            transform: translateY(-5px);
            border-color: rgba(44, 172, 226, 0.38);
            box-shadow: 0 22px 42px rgba(20, 34, 53, 0.12);

            .item-list-more {
              color: #156da8;
            }
          }

          .card-link {
            display: flex;
            flex-direction: column;
            height: 100%;
            color: inherit;
          }

          .item-img {
            width: 100%;
            height: 170px;
            background-color: #dbe8f1;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
          }

          &-body {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 20px 22px 22px;
            box-sizing: border-box;
          }

          &-meta {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            color: #8394a7;
            font-size: 13px;

            span {
              color: #156da8;
              font-weight: 700;
            }
          }

          &-title {
            margin-top: 12px;
            color: #142235;
            font-size: 20px;
            line-height: 1.45;
            min-height: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          &-content {
            margin-top: 10px;
            color: #607286;
            font-size: 14px;
            line-height: 1.7;
            height: 70px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
          }

          &-more {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            margin-top: auto;
            padding-top: 16px;
            color: #2b5f86;
            font-size: 14px;
            font-weight: 700;
            transition: color 0.25s ease;
          }
        }
      }

      .empty-news {
        min-height: 260px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #7d8fa3;

        i {
          font-size: 42px;
          color: #b7c7d8;
        }

        p {
          margin-top: 12px;
          font-size: 16px;
        }
      }
    }
  }

  .text-decoration {
    text-decoration: none;
  }
}

@media (max-width: 1024px) {
  .news-section-content {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }

  .news .news-section-content .content-nav-item {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 680px) {
  .news-section-content {
    width: 94% !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .news .news-section-content .section-title h2 {
    font-size: 30px;
  }

  .news .news-section-content .content-nav-item {
    grid-template-columns: 1fr;
  }
}
</style>
